module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.hasDescription) ? _c('div', {
    staticClass: "pb-3"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.prefix)
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "ds-textfield inline small",
    attrs: {
      "type": "number",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.sizeInput),
      callback: function($$v) {
        _vm.sizeInput = _vm._n($$v)
      },
      expression: "sizeInput"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.suffix)
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.forecast), function(time) {
    return [_c('ds-calendar-event-chip', {
      key: time.time,
      attrs: {
        "day": _vm.aroundDay,
        "time": time,
        "can-exclude": _vm.canExclude && !_vm.isReadOnly
      },
      on: {
        "exclude": _vm.exclude
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e912d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleForecast.vue
// module id = 417
// module chunks = 1